import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.checkEmpty();
  }

  removeIfEmpty(event) {
    if (event.target.children.length === 0) {
      event.target.remove();
    }
  }

  checkEmpty() {
    if (this.element.childElementCount === 0) {
      this.element.remove();
    }
  }
}
